var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ChatActivityBreakdown from '@web/components/Apps/Chat/ChatActivityBreakdown';
import ChatSummary from '@web/components/Apps/Chat/ChatSummary';
import { TopChatSpaces } from '@web/components/Apps/Chat/TopChatSpaces';
import { TopChatters } from '@web/components/Apps/Chat/TopChatters';
import { ActivityLabelFilterSelect } from '@web/components/Filters/Elements/ActivityLabel';
import StickyFilters from '@web/components/Filters/StickyFilters';
import { ActivityLabelTargetEnum } from '@workalizer/shared';
function ChatTab() {
    return (_jsxs(_Fragment, { children: [_jsx(StickyFilters, { additionalFilters: _jsx(ActivityLabelFilterSelect, { labelTargets: [
                        ActivityLabelTargetEnum.CHAT_ROOM_NAMES,
                        ActivityLabelTargetEnum.ALL
                    ] }) }), _jsxs("div", __assign({ className: "flex flex-col mx-1 gap-20 mt-5" }, { children: [_jsx(ChatSummary, {}), _jsx(ChatActivityBreakdown, {}), _jsx(TopChatSpaces, {}), _jsx(TopChatters, {})] }))] }));
}
export default ChatTab;
